<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { buttonProps } from './button'

defineOptions({
  name: 'VsButton',
})

const props = defineProps(buttonProps)

// init here
</script>
